@use "../../styles/breakpoint.module.scss" as *;

.panel {
    grid-column: 4 / span 6;

    @media ($below-tablet) {
        grid-column: 3 / span 8;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}
